/*
 © Copyright 2026 Daikin Industries, Ltd. All rights reserved.

 This software is the proprietary information of Daikin Industries, Ltd.
 By using this software, you agree to the following terms:

 1. You are granted a revocable non-exclusive, non-transferable license to use this software.
 2. You agree not to modify, distribute, or create derivative works based on this software.
 3. Unauthorized copying, distribution, or use of any portion of this software is strictly prohibited.
 4. This software is protected by copyright laws and international treaties.
 5. Any violation of these terms will result in the termination of your license and may result in legal action.
 6. This is Daikin's proprietary software and may not be used in an unauthorized manner or without express authorization from Daikin.
*/

import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationResult } from '@azure/msal-browser';

@Injectable({
  providedIn: 'root'
})
export class RedirectService {

  constructor(
    private router: Router,
    private msalService: MsalService
  ) {}

  async handleRedirectPromise(): Promise<void> {
    try {
      const response: AuthenticationResult | null = await this.msalService.instance.handleRedirectPromise();

      if (response) {
        console.log('Redirect response received:', response);

        // Set active account
        const accounts = this.msalService.instance.getAllAccounts();
        if (accounts.length > 0) {
          this.msalService.instance.setActiveAccount(accounts[0]);
          console.log('Active account set:', accounts[0]);
        }

        // Navigate to intended route or home
        const currentUrl = window.location.pathname;
        if (currentUrl === '/' || currentUrl.includes('login') || currentUrl.includes('auth')) {
          this.router.navigate(['/']);
        }
      }
    } catch (error) {
      console.error('Error handling redirect promise:', error);
    }
  }
}
